// removed by extract-text-webpack-plugin
module.exports = {"section-container":"ServicesSection__section-container___1sRqX","cards-container":"ServicesSection__cards-container___1Vv6s"};